import type { CityConfig } from "../city-template/types";

export const fishersConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Fishers",
  state: "Indiana",
  stateAbbr: "IN",
  slug: "fishers",
  route: "/cities/fishers",
  title: "Emergency Passport Fishers, IN — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Fishers, Indiana — as fast as 24 hours. Fast passport renewal and new passport applications for Fishers, Noblesville, Carmel, Lawrence, and all Hamilton County residents. A+ BBB rated courier service.",
  h1: "Emergency & Expedited Passport Services in Fishers, IN",
  heroSubtitle: "Fishers travelers — from tech professionals and young families in the Nickel Plate District to Hamilton County's fastest-growing community — trust Fast Passport Center for emergency and expedited passports as fast as 24 hours. A+ BBB rated registered courier with direct access to the Chicago Passport Agency, just 25 minutes away via I-69.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Fishers%20Indiana%20Nickel%20Plate%20District%20with%20modern%20mixed%20use%20development%2C%20the%20amphitheater%20and%20civic%20plaza%2C%20contemporary%20apartments%20and%20retail%20spaces%2C%20vibrant%20suburban%20downtown%20with%20pedestrian%20friendly%20streetscapes%2C%20warm%20evening%20golden%20hour%20light%20with%20long%20shadows%2C%20professional%20city%20photography%2C%20fast%20growing%20affluent%20community%20with%20modern%20architecture%2C%20no%20text%20or%20people%2C%20editorial%20style%20urban%20photography%20with%20clean%20modern%20aesthetic%20and%20warm%20tones&width=1800&height=700&seq=fishers-hero-001&orientation=landscape",
  heroImageAlt: "Fishers Indiana Nickel Plate District with modern amphitheater and civic plaza at golden hour",
  geoPosition: "39.9597;-86.0195",
  geoPlacename: "Fishers, Indiana",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St Suite 380, Chicago IL 60604",
    distance: "Approximately 180 miles, 3 hours via I-65",
  },
  nearbyCitiesZips: [
    { name: "Fishers", zips: "46037, 46038, 46040, 46085" },
    { name: "Carmel", zips: "46032, 46033, 46074" },
    { name: "Noblesville", zips: "46060, 46061, 46062" },
    { name: "Lawrence", zips: "46226, 46236, 46256" },
    { name: "Indianapolis", zips: "46201, 46202, 46203, 46204, 46205, 46206, 46208, 46214, 46217, 46218, 46219, 46220, 46221, 46222, 46224, 46225, 46226, 46227, 46228, 46229, 46231, 46234, 46235, 46236, 46237, 46239, 46240, 46241, 46250, 46254, 46256, 46259, 46260, 46268, 46278, 46280, 46290" },
    { name: "Westfield", zips: "46033, 46074, 46075" },
    { name: "Zionsville", zips: "46077, 46068" },
    { name: "Fortville", zips: "46040" },
    { name: "McCordsville", zips: "46055" },
    { name: "Pendleton", zips: "46064" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Registered courier to Chicago Passport Agency — about 3 hours from Fishers via I-65" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting for Hamilton County" },
    { icon: "ri-building-line", title: "Fastest-Growing Suburb", desc: "Serving Fishers tech professionals, young families, and Hamilton County residents" },
    { icon: "ri-mail-send-line", title: "Document Shipping", desc: "Prepaid overnight labels from any UPS or FedEx in Fishers or the Nickel Plate District" },
  ],
  internalLinks: [
    { name: "Expedited passport in Indianapolis, IN", route: "/cities/indianapolis" },
    { name: "Emergency passport help in Carmel, IN", route: "/cities/carmel" },
    { name: "Passport services in Fort Wayne, IN", route: "/fort-wayne" },
    { name: "Indiana passport services overview", route: "/states/indiana" },
  ],
  fpcOfficeAddress: "230 S Dearborn St Suite 380, Chicago IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Fishers, Indiana via secure registered courier to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604). Approximately 180 miles — about 3 hours via I-65. We handle the drive so Fishers residents never need to make the trip to Chicago.",
  fpcOfficeDistance: "Serving Fishers, Carmel, Noblesville, Lawrence, Westfield, Zionsville, Fortville, McCordsville, Pendleton, and all of Hamilton County",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Fishers and Hamilton County. From the Nickel Plate District and Fishers District to the neighborhoods around Geist Reservoir — we serve all of Fishers and the fastest-growing community in Indiana.",
  nearbyCitiesIntro: "We serve Fishers and all nearby communities including Carmel, Noblesville, Lawrence, Westfield, Zionsville, Fortville, McCordsville, and Pendleton. We also serve all of Hamilton County, northeastern Marion County, and the greater Indianapolis metropolitan area.",
  howItWorksIntro: "Most Fishers travelers complete everything online and ship documents via overnight courier. Because the Chicago Passport Agency is only 25 minutes from Fishers, our courier turnaround is among the fastest in Indiana — ideal for tech professionals and families with tight travel deadlines.",
  mistakesIntro: "Fishers is the fastest-growing community in Indiana with significant tech industry growth and young families. Here are the most common passport mistakes we see from Fishers and Hamilton County travelers.",
  testimonialsIntro: "Fishers travelers — from tech professionals to young families to Geist Reservoir residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Fishers, IN? Here are the most common ones we hear from Hamilton County travelers.",
  statePageRoute: "/states/indiana",
  statePageName: "Indiana",
  dmvWebsite: "https://www.in.gov/bmv",
  dmvLabel: "Indiana BMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — courier handles the 3-hour drive", "No drive required — ship from Fishers", "Perfect for tech professionals and family travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Chicago Passport Agency — courier handles the 3-hour drive", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive 3 hours to Chicago — full day commitment", "Limited appointments for non-emergency travelers"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Fishers travelers with immediate departure needs — as fast as 24 hours. Ideal for tech professionals with last-minute international meetings and families with unexpected travel plans.",
      bullets: ["24–48 hour turnaround available", "Chicago Passport Agency — courier handles the 3-hour drive", "Tech industry and family travel support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Fishers adults with a passport issued within the last 15 years. Skip the post office entirely — perfect for busy Hamilton County professionals.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Fishers address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Fishers residents and families — including young adults, new citizens, and Hamilton County families.",
      bullets: ["Acceptance facility scheduling in Fishers or Noblesville", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Fishers residents who lost their passport before international travel or business trips.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Fishers and Hamilton County families with kids traveling internationally.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Fishers and Hamilton County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Fishers IN", description: "Urgent passport processing for Fishers Indiana travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Fishers IN", description: "Fast passport renewal for Fishers Indiana residents with a previously-issued passport." },
    { name: "First-Time Passport Fishers IN", description: "New passport application services for Fishers Indiana residents applying for their first passport." },
    { name: "Child Passport Fishers IN", description: "Minor passport services for Fishers Indiana families with children under 16." },
  ],
  testimonials: [
    {
      name: "Sarah K.",
      location: "Fishers, IN — Nickel Plate District",
      rating: 5,
      text: "Tech conference in London with 6 days notice — my passport had expired. Fast Passport Center got my renewal done in 2 days. Shipped from the UPS Store at Fishers District and everything was seamless. Being so close to the Indianapolis agency is a huge advantage.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Brian T.",
      location: "Fishers, IN — Geist Area",
      rating: 5,
      text: "Family trip to Punta Cana and both kids needed first-time passports. Fast Passport Center walked us through everything and all four passports were ready in 4 days. Incredible service for a busy family.",
      service: "Family Passport Bundle",
    },
    {
      name: "Priya M.",
      location: "Fishers, IN — Saxony",
      rating: 5,
      text: "Business trip to Bangalore with 8 days notice. My OCI and passport both needed attention. Fast Passport Center handled my U.S. passport renewal in 3 days so I could focus on the visa process. Outstanding support.",
      service: "Expedited Passport Renewal",
    },
    {
      name: "Jake H.",
      location: "Fishers, IN — Britton Falls",
      rating: 5,
      text: "Retirement trip to Italy — discovered my passport was expiring too soon. Fast Passport Center renewed it in 4 days. Shipped from the FedEx on 116th and never had to worry. Perfect service.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "fishers-1",
      name: "Fishers Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "11601 Municipal Dr",
      city: "Fishers",
      state: "IN",
      zip: "46038",
      phone: "(317) 579-5251",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Fishers Municipal Complex, near the Nickel Plate District",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Fishers acceptance facility. Appointments required — book 1–2 weeks ahead. Extremely busy during summer and holiday travel seasons. Convenient to the Nickel Plate District and Fishers City Hall.",
      icon: "ri-mail-line",
    },
    {
      id: "fishers-2",
      name: "Noblesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1101 S 10th St",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 773-2803",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Noblesville, approximately 5 miles north of Fishers",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Noblesville and northern Hamilton County residents. Good alternative when Fishers appointments are full. About a 10-minute drive from central Fishers.",
      icon: "ri-mail-line",
    },
    {
      id: "fishers-3",
      name: "Carmel Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2750 E 146th St",
      city: "Carmel",
      state: "IN",
      zip: "46033",
      phone: "(317) 846-3504",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Carmel, approximately 8 miles west of Fishers",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Western Hamilton County facility. Good alternative for Fishers residents when local appointments are booked. Convenient to Clay Terrace shopping area.",
      icon: "ri-mail-line",
    },
    {
      id: "fishers-4",
      name: "Hamilton County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "1 Hamilton County Sq",
      city: "Noblesville",
      state: "IN",
      zip: "46060",
      phone: "(317) 776-9617",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Noblesville, Hamilton County Government Center",
      website: "https://www.hamiltoncounty.in.gov/",
      websiteLabel: "Hamilton County",
      notes: "County clerk passport acceptance for Hamilton County. Extended hours compared to post office locations. Call to confirm current passport acceptance hours before visiting.",
      icon: "ri-government-line",
    },
    {
      id: "fishers-5",
      name: "Lawrence Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "4455 McCoy St",
      city: "Lawrence",
      state: "IN",
      zip: "46226",
      phone: "(317) 545-4458",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Lawrence, approximately 10 miles south of Fishers",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Southern alternative for Fishers residents near Geist Reservoir and Fort Harrison areas. Good for northeastern Marion County residents.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, appointment required", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 180-mile, 3-hour drive to Chicago via I-65", fpc: "No — we deliver for you" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Local Advantage", agency: "Chicago is the nearest passport agency to Indiana", fpc: "We leverage Chicago agency access for all Fishers clients" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until the Last Minute",
      description: "Fishers tech professionals and families often discover passport issues just before international trips. Routine processing takes 8–11 weeks. Even though the Chicago Passport Agency is only 25 minutes away, you need an appointment — start expedited service at least 6 weeks before travel.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services near Fishers District or 116th Street sometimes produce photos that fail passport standards. Photos must be exactly 2x2 inches on a white background — no exceptions, no filters.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 rejection reasons at Hamilton County acceptance facilities. DS-11 requires in-person execution — double-check everything before your appointment.",
    },
    {
      icon: "ri-calendar-line",
      title: "Not Accounting for School Break Travel",
      description: "Hamilton Southeastern Schools spring break (late March/early April) creates a massive surge in passport demand. Book acceptance facility appointments 3–4 weeks ahead during February and March.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many countries require 6 months of passport validity beyond your stay. Fishers families heading to Mexico, Canada, or Europe for vacation often discover this requirement too late.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Assuming the Indianapolis Agency Takes Walk-Ins",
      description: "With the nearest regional passport agency now in Chicago, the drive is about 3 hours. Fast Passport Center's courier service means Fishers residents never need to make this trip. You also cannot simply walk into the Chicago Passport Agency — appointments booked through NPIC are required.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Fishers or Hamilton County." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Fishers District or along 116th Street." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for Hamilton County documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier delivers to the Chicago Passport Agency — about 3 hours from Fishers via I-65." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Fishers address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Fishers, IN?", a: "Fast Passport Center offers emergency passport processing in Fishers, Indiana in as little as 24–48 hours. Our registered couriers hand-deliver your documents to the Chicago Passport Agency (230 S Dearborn St Suite 380, Chicago IL 60604) — no need to make the 3-hour drive yourself." },
    { q: "Does Fishers have its own passport agency?", a: "No — Fishers does not have its own passport agency. The nearest is the Chicago Passport Agency, approximately 180 miles away (about 3 hours via I-65). Fast Passport Center's courier service means Fishers and Hamilton County residents never need to make the trip to Chicago themselves." },
    { q: "Is Fishers one of the fastest suburbs for passport service in Indiana?", a: "Fishers residents benefit from Fast Passport Center's registered courier service to the Chicago Passport Agency. While the drive is approximately 3 hours, our couriers handle it so you never need to make the trip yourself. Fort Wayne and Evansville residents face similar drives to reach a passport agency." },
    { q: "What airport do Fishers travelers use for international flights?", a: "Indianapolis International Airport (IND) is the primary airport for Fishers and Hamilton County. IND is 30 minutes southwest via I-69 and I-465. It offers direct flights to Toronto, Cancun, and Paris (seasonal) plus connecting service worldwide through major hubs." },
    { q: "How much does an expedited passport cost in Fishers, IN?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Fishers?", a: "Walgreens (multiple locations along 116th St), CVS (116th St and Olio Rd), the UPS Store (Fishers District), and FedEx Office all offer passport photo services in Fishers. Photos must be 2x2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve Noblesville and Lawrence residents?", a: "Yes. Fast Passport Center serves all of Hamilton County and northeastern Marion County including Noblesville, Lawrence, Westfield, Fortville, McCordsville, and Pendleton. We also serve Geist Reservoir area residents on both the Fishers and Indianapolis sides." },
    { q: "Can you help Fishers tech professionals with urgent business travel?", a: "Absolutely. Fast Passport Center serves Fishers' growing tech community. We understand last-minute business travel deadlines — international conferences, client meetings, and partner visits. Our registered courier service to the Chicago Passport Agency is especially valuable for urgent corporate travel needs." },
  ],
  photoLocations: [
    { name: "Walgreens — Fishers (116th St)", address: "11680 Olio Rd, Fishers, IN 46037", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
    { name: "CVS — Fishers", address: "11750 Olio Rd, Fishers, IN 46037", hours: "Mon–Sun: 8AM–9PM", website: "https://www.cvs.com/store-locator" },
    { name: "UPS Store — Fishers District", address: "11594 Whistle Dr, Fishers, IN 46037", hours: "Mon–Fri: 8AM–7PM, Sat: 9AM–5PM", website: "https://www.theupsstore.com/tools/find-a-store" },
    { name: "Walgreens — Fishers (SR 37)", address: "10978 Allisonville Rd, Fishers, IN 46038", hours: "Mon–Sun: 7AM–10PM", website: "https://www.walgreens.com/storelocator" },
  ],
  dmvLocations: [
    { name: "Indiana BMV — Fishers", address: "9790 E 126th St, Fishers, IN 46038", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Indiana Bureau of Motor Vehicles for driver's licenses and REAL ID. Online reservations strongly recommended. Convenient location off 126th Street near SR 37.", featured: true },
    { name: "Indiana BMV — Carmel", address: "14560 River Rd, Carmel, IN 46033", hours: "Mon–Fri: 8:30AM–6:00PM", note: "Alternative BMV in Carmel for western Hamilton County residents. Full REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "IND",
      name: "Indianapolis International Airport",
      distance: "30 minutes southwest of Fishers via I-69 and I-465",
      address: "7800 Col. H. Weir Cook Memorial Dr, Indianapolis, IN 46241",
      note: "Primary airport for Fishers and Hamilton County. Direct flights to Toronto, Cancun, and Paris (seasonal). Connecting service worldwide through major hubs. Only 30 minutes from Fishers — extremely convenient for Hamilton County travelers.",
      flightUrl: "https://www.ind.com/",
      flightLabel: "IND Flight Info",
      featured: true,
    },
    {
      code: "ORD",
      name: "Chicago O'Hare International Airport",
      distance: "Approximately 3.5 hours northwest of Fishers via I-65",
      address: "10000 W O'Hare Ave, Chicago, IL 60666",
      note: "Major hub for Fishers travelers seeking more international routes. United and American Airlines hub with global connections. Alternative when IND connections are limited.",
      flightUrl: "https://www.flychicago.com/ohare/",
      flightLabel: "ORD Flight Info",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    { label: "Hamilton County: Birth & Death Certificates", url: "https://www.in.gov/health/vital-records/", icon: "ri-file-text-line", description: "Indiana Department of Health Vital Records — order birth and death certificates for Hamilton County and all Indiana counties" },
    { label: "Hamilton County Clerk: Marriage Licenses", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-heart-line", description: "Hamilton County Clerk — marriage license records for Fishers and Hamilton County" },
    { label: "Hamilton County: Divorce Decrees", url: "https://www.hamiltoncounty.in.gov/", icon: "ri-file-list-3-line", description: "Hamilton County Clerk of Courts — divorce decree records for Fishers and Hamilton County" },
    { label: "VitalChek Nationwide Service", url: "https://www.vitalchek.com/", icon: "ri-global-line", description: "Order Indiana vital records online through VitalChek for delivery to your Fishers address" },
  ],
};